
import * as React from 'react';
import {
  IDetailsListProps
} from 'office-ui-fabric-react/lib/DetailsList';
import {
  ISelection
} from 'office-ui-fabric-react/lib/Selection';
import { withCurrentItemSet, IDecorateWithCurrentItemSetProps } from '../decorators/selectors';
import { withCurrentGroups, IDecorateWithCurrentGroupsProps } from '../decorators/withCollapsibleGroups';
import {
  connectInvocationAction, IConnectedToInvocationProps, IDecorateConnectToInvocationActionProps
} from '../decorators/connectToInvocationAction';
import { ItemDefaultClickAction } from '../actions/defaultClick/DefaultClickAction';
import {
  withItemSetSelection, IDecorateConnectToSelectionProps
} from '../decorators/connectToSelection';
import { withPageLoadTracker, IDecorateWithPageLoadTrackerProps } from '../decorators/withPageLoadTracker';
import { asLayout, IDecorateAsLayoutProps } from '../layoutManager/LayoutManager';
import { detailsLayoutType, compactDetailsLayoutType } from './DetailsLayoutTypeFacet';
import { IItemSetDetailsListProps, ItemSetDetailsList } from '../itemSetDetailsList/ItemSetDetailsList';
import { injectProps } from '../../utilities/components/Props';

const CurrentItemSetDetailsList = withCurrentItemSet()(withCurrentGroups()(ItemSetDetailsList));
const InvokableDetailsList = connectInvocationAction(ItemDefaultClickAction, (
  invocationProps: IConnectedToInvocationProps
): Pick<IDetailsListProps, 'onItemInvoked' | 'onItemContextMenu'> => {
  return {
    onItemInvoked: invocationProps.onItemInvoked,
    onItemContextMenu: invocationProps.onItemContextMenu
  };
})(CurrentItemSetDetailsList);
const SelectionDetailsList = withItemSetSelection((selection: ISelection): Pick<IDetailsListProps, 'selection'> => {
  return {
    selection: selection
  };
})(InvokableDetailsList);
const PageLoadDetailsList = withPageLoadTracker([])(SelectionDetailsList);

export type IDetailsLayoutProps =
  IDecorateAsLayoutProps<IDecorateWithPageLoadTrackerProps<
  IDecorateConnectToSelectionProps<
  IDecorateConnectToInvocationActionProps<
  IDecorateWithCurrentGroupsProps<
  IDecorateWithCurrentItemSetProps<
  IItemSetDetailsListProps
  >
  >,
  Pick<IDetailsListProps, 'onItemInvoked' | 'onItemContextMenu'>,
  {}>,
  Pick<IDetailsListProps, 'selection'>,
  {}
  >
  >>;

export const DetailsLayout: React.ComponentType<IDetailsLayoutProps> = asLayout(detailsLayoutType)(PageLoadDetailsList);

export const CompactDetailsLayout: React.ComponentType<IDetailsLayoutProps> = asLayout(compactDetailsLayoutType)(
  injectProps((): Pick<IDetailsLayoutProps, 'compact'> => {
    return {
      compact: true
    };
  })(PageLoadDetailsList)
);
